<script lang="ts">
	import { groups } from 'src/stores/lists/groups';
	import { rooms } from 'src/stores/lists/rooms';
	import {
		navigateToShop,
		sortByPosition,
	} from '../../../../../../../../components/Lists/list-helpers';
	import { _init_group_actions } from '../../../../../../helpers/init_group_actions';
	import { _deepClone, _deepCopyArr, capFirstChar } from '../../../../../../../../helpers/utilities';
	import { is_group_action_ui } from 'src/types/GroupActionUI';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { format } from 'svelte-i18n';
	import { DO_WIZARD_STEPS_INDEXES, bootstrapEditedGroupAction } from '../../helpers/do-wizard-helpers';
	import EmptyList from 'src/components/Lists/EmptyList.svelte';

	export let sceneData: any;
	export let firstSelectedRef: HTMLElement = null;

	if (is_group_action_ui(sceneData.translated)) {
		bootstrapEditedGroupAction(sceneData, $groups);
	}

	const validateWizardStepSelectGroup = () => {
		sceneData.isValid = false;
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.CHANGE_STATE;
		sceneData = _deepClone({
			...sceneData,
			groupAction: {
				...sceneData.groupAction,
				actions: _deepCopyArr([]),
			},
		});
	};

	const onSelectGroup = (e) => {
		validateWizardStepSelectGroup();
		const group = e.detail;
		sceneData.selectedGroup = { ...group };
		sceneData.groupAction.components = _init_group_actions[$groups[group.id]?.type]() || [];
	};

	const getGroupByRoomID = (roomID) => {
		return (
			Object.values($groups)
				.filter(
					(group: any) =>
						group.room_id === roomID && ['relay', 'light', 'roller'].includes(group.type),
				)
				.map((group: any) => {
					return { ...group };
				}) || []
		);
	};

	const mapRoomGroupSelectedProp = (room, groupSelected) => {
		const updatedCards = room.cards.map((group) => {
			if (group.id === groupSelected?.id) {
				return {
					...group,
					selected: true,
				};
			}
			return {
				...group,
				selected: false,
			};
		});

		return {
			...room,
			cards: updatedCards,
		};
	};

	$: sortedRoomsWithGroups = [
		{ id: -1, name: 'Global', position: -1 } as any,
		...Object.values($rooms),
	]
		.sort(sortByPosition)
		.map((room: any) => {
			return {
				cards: getGroupByRoomID(room.id).sort(sortByPosition),
				roomID: room.id,
				roomName: room.name,
			};
		})
		.filter((room) => {
			return room.cards.length > 0;
		})
		.map((room) => {
			return mapRoomGroupSelectedProp(room, sceneData.selectedGroup);
		});

	$: {
		if (
			sceneData.do_info.mode === 'edit' &&
			(Object.keys(sceneData.selectedGroup).length === 0 || !$groups[sceneData.selectedGroup?.id])
		) {
			sceneData.isValid = false;
			sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.GROUP_STEP;
		}
	}
</script>

<SelectList
	class="mb-s"
	title={$format('label_select_group', {
		default: 'Select group',
	})}
	list={sortedRoomsWithGroups}
	variant="radio"
	selectedCardsId={[sceneData.selectedGroup]}
	on:click={(e) => onSelectGroup(e)}
	bind:firstSelectedRef
/>

{#if !sortedRoomsWithGroups.length}
	<div class="d-flex flex-direction-column justify-content-center align-items-center mt-s">
		<EmptyList
			withoutMargin
			type="modal"
			title={$format('on_board_get_device_title', {
				default: 'Get the necessary devices to set up.',
			})}
			description={$format('on_board_get_device_description', {
				default:
					'Currently you don’t have the necessary devices. Please get the necessary devices to set up your automations.',
			})}
			btnText={capFirstChar(
				$format('button_go_to_store', {
					default: 'Go to store',
				}).toLocaleLowerCase(),
			)}
			onClick={() => {
				navigateToShop();
			}}
		/>
	</div>
{/if}
